import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const LabelBGWithIconWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.space_size};
  height: 100%;
  span {
    font-size: 14px;
    color: ${theme.colours.DavysGrey};
    display: flex;
    font-family: ${theme.fonts.Medium};
    justify-content: flex-start;
    align-items: center;
    color: ${theme.colours.black};
    font-family: ${theme.fonts.Regular};
    font-weight: 600;
    &:first-child {
      width: 20px;
      height: 20px;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${theme.colours.AntiFlashWhite};
    }
  }
`;
